export const MAIN_ASSET_ID = "0000000000000000000000000000000000000000000000000000000000000000";
export const SEARCH_LIMIT = 75;
export const MILKOMEDA_BLOCK_TIME_SECONDS = 4000;
export enum BoxColor {
  DEFAULT = "DEFAULT",
  WHITE = "WHITE",
  PRIMARY = "PRIMARY",
}
